import {createContext} from 'react'

const EstatusOrdenCompraContext = createContext()

export default EstatusOrdenCompraContext